import React, { useState } from "react";
import {
    customColumnProps,
    DynamicTable,
} from "@maherunlocker/custom-react-table";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";

import { store } from "../store";

import { CustomIcons } from "./CustomIcons";
import { useAuthHeader } from "../../../../../api/headersKeycloak";
import { useSyncDefaultSettingApplications } from "./hooks";
import { DynamicTableDataType } from "./types";

export function Application() {
    const { t } = useTranslation();
    const getAuthHeader = useAuthHeader();
    const [filterActive, setLocalFilterActive] = useState<boolean>(false);
    const [dataIsUpdated, setDataIsUpdated] = useState<boolean | number>(false);
    const [data, setData] = useState<DynamicTableDataType>({});
    const { defaultSetting } = useSnapshot(store);

    let arrayOfCustomColumns: customColumnProps[] = [
        {
            indexOFColumn: 7,
            columnName: t("Nombre d'applications"),
            customJsx: (e: any) => <CustomIcons e={e} />,
            disableFilter: false,
        },
    ];

    useSyncDefaultSettingApplications(data, defaultSetting);

    return (
        <div>
            <h2 className="mt-3 ml-3">{t("Applications")}</h2>
            <DynamicTable
                canMovedCheckboxLeftOnExpand
                url={"/DefaultSetting/applications.json"}
                setData={setData}
                canSelect
                customSelect
                canResize
                showGlobalFilter
                showFilter
                setLocalFilterActive={setLocalFilterActive}
                filterActive={filterActive}
                actionColumn={() => <></>}
                arrayOfCustomColumns={arrayOfCustomColumns}
                setDataIsUpdated={setDataIsUpdated}
                dataIsUpdated={dataIsUpdated}
                elevationTable={1}
                minHeight={"450px"}
                maxHeight={"450px"}
                name="tva"
                requestHeader={{
                    ...getAuthHeader,
                }}
            />
        </div>
    );
}
